export default "__VITE_ASSET__ffc2ae56__"